module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/PatriotGames.9b5cd05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/PatriotGames.jpg
// module id = BEZ9
// module chunks = 0